"use strict";
// Copyright (c) StrangeBee 2024
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamLongPollingController = exports.StreamController = void 0;
var StreamController_1 = require("./StreamController");
Object.defineProperty(exports, "StreamController", { enumerable: true, get: function () { return __importDefault(StreamController_1).default; } });
var StreamController_2 = require("./StreamController");
Object.defineProperty(exports, "StreamLongPollingController", { enumerable: true, get: function () { return StreamController_2.StreamLongPollingController; } });
